const rules = {
    backToDiagram: false,
    showRuleTesting: false,
    showInstanceTable: false,
    currentRule: {},
    testedRules: null,
    testAllRules: false,
    levels: {
        currentLevel: {}
    },
    selectedCondition: ""
};
export default rules;
